import { render } from "./LbrxCart.vue?vue&type=template&id=3b0a9a66&scoped=true"
import script from "./LbrxCart.vue?vue&type=script&lang=js"
export * from "./LbrxCart.vue?vue&type=script&lang=js"

import "./LbrxCart.vue?vue&type=style&index=0&id=3b0a9a66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0a9a66"]])

export default __exports__